import { appendScript } from 'utilities/appendScript'
import { FORTER_SCRIPT } from 'constants/forterScript'
import store from 'store'

export function useForterScript() {
  if (!store.getters['setting/isForterEnabled']) return

  appendScript(
    'head',
    `<script id="dc2ee488b13d" type="text/javascript">${FORTER_SCRIPT}<` + '/script>'
  )
}
